module.exports = __webpack_public_path__ + "static/media/hair11.f87a8e33.png";